import React, { useState, useEffect, useRef } from "react";
import { Divider, Typography, makeStyles } from "@material-ui/core";
import moment from "moment";

import Table from "../../components/Table";
import { Card, CardContent, CardActions } from "../../components/Card";
import PageItem from "../../components/PageItem";
import Grid from "../../components/Grid";
import Button from "../../components/Button";
import { Select, DateInput, TextInput } from "../../components/Form";

export default function OnlineUsersTable() {
  const [newData, setNewData] = useState({
    signal: "",
    ip: "",
    statisticsTimeStart: null,
    statisticsTimeEnd: null,
    quantityArray: [
      {
        label: "30筆",
        value: "30筆",
      },
      {
        label: "50筆",
        value: "50筆",
      },
      {
        label: "100筆",
        value: "100筆",
      },
    ],
    quantityObject: {
      label: "30筆",
      value: "30筆",
    },
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
    data: [],
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  const useStyles = makeStyles({
    DocumentContainerRow: {
      display: "flex",
      flexDirection: "row",
    },
    DocumentContainerEnd: {
      display: "flex",
      alignItems: "flex-end",
    },
  });
  const classes = useStyles();
  return (
    <Card>
      <CardContent>
        <Grid container item spacing={1}>
          <Grid container item spacing={1}>
            <Grid item xs={6} sm={2}>
              <Typography color="primary">查詢期間</Typography>
              <DateInput
                inputVariant="outlined"
                format="yyyy年MM月dd日"
                value={newData.statisticsTimeStart}
                onChange={(v) => changeData("statisticsTimeStart", v, true)}
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography color="primary">至</Typography>
              <DateInput
                inputVariant="outlined"
                format="yyyy年MM月dd日"
                value={newData.statisticsTimeEnd}
                minDate={newData.statisticsTimeStart}
                onChange={(v) => changeData("statisticsTimeEnd", v, true)}
                fullWidth
              />
            </Grid>
            <Grid item xs={4} sm={2}>
              <Typography color="primary">查詢姓名</Typography>
              <TextInput
                value={newData.signal}
                onChange={(v) => changeData("signal", v, true)}
                fullWidth
              />
            </Grid>
            <Grid item xs={4} sm={2}>
              <Typography color="primary">查詢IP</Typography>
              <TextInput
                value={newData.ip}
                onChange={(v) => changeData("ip", v, true)}
                fullWidth
              />
            </Grid>
            <Grid item xs={4} sm={2}>
              <Typography color="primary">顯示筆數</Typography>
              <Select
                items={newData.quantityArray}
                value={newData.quantityObject}
                onChange={(e, v) => changeData("quantityObject", v, true)}
                fullWidth
              />
            </Grid>
            <Grid item classes={{ root: classes.DocumentContainerEnd }}>
              <Button color="primary" variant="contained" onPress={() => {}}>
                查詢
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <CardContent>
        <Grid container justify="center">
          <Typography style={{ fontSize: 20 }}>目前在線人數</Typography>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <Table
          data={newData.data}
          header={["來源", "姓名", "IP", "登入時間"]}
          columns={[]}
        />
      </CardContent>
      <CardActions>
        <PageItem
          data={newData.pageArray}
          page={newData.page}
          onChangePage={(e) => changeData("page", e, true)}
        />
      </CardActions>
      <Divider />
      <CardContent>
        <Grid container justify="center">
          <Typography style={{ fontSize: 20 }}>登入排行榜</Typography>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <Table
          data={newData.data}
          header={["來源", "名次", "姓名", "IP", "登入時間", "登入次數"]}
          columns={[]}
        />
      </CardContent>
      <CardActions>
        <PageItem
          data={newData.pageArray}
          page={newData.page}
          onChangePage={(e) => changeData("page", e, true)}
        />
      </CardActions>
    </Card>
  );
}
